import * as React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor: FillColor;
  className: ClassName;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const PodcastIcon = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g fill="none" fillRule="evenodd">
      <g fill={fillColor} fillRule="nonzero">
        <path d="M1.944,-5.32907052e-15 L30.056,-5.32907052e-15 C31.1296416,-5.52629527e-15 32,0.870358446 32,1.944 L32,30.056 C32,31.1296416 31.1296416,32 30.056,32 L1.944,32 C0.870358446,32 -4.30940893e-15,31.1296416 -4.4408921e-15,30.056 L-5.32907052e-15,1.944 C-5.46055369e-15,0.870358446 0.870358446,-4.24366734e-15 1.944,-4.4408921e-15 Z M11.8546584,15.9012998 C10.1462288,14.9465904 7.24916989,18.6279318 3.16348155,26.945324 C3.06521662,27.1453656 3.01412092,27.3652728 3.01412092,27.5881464 C3.01412092,28.393366 3.66688033,29.0461254 4.47209987,29.0461254 L28.0349696,29.0461464 C28.2167659,29.0461464 28.3969587,29.0121469 28.5662554,28.9459013 C29.3161193,28.6524803 29.6861394,27.8067307 29.3927241,27.0568646 C27.3742811,21.8985511 25.6050352,19.0869615 24.0849864,18.622096 C21.5272014,17.8398671 19.4986134,21.3428922 17.9698224,21.3428922 C16.4410314,21.3428922 14.6237882,17.4487526 11.8546584,15.9012998 Z M24.8615385,9.05345502 C26.3569556,9.05345502 27.5692308,7.84117988 27.5692308,6.34576271 C27.5692308,4.85034554 26.3569556,3.6380704 24.8615385,3.6380704 C23.3661213,3.6380704 22.1538462,4.85034554 22.1538462,6.34576271 C22.1538462,7.84117988 23.3661213,9.05345502 24.8615385,9.05345502 Z M3.54211213,10.3468057 C2.86237705,10.3468057 2.31134289,10.8978399 2.31134289,11.577575 C2.31134289,12.25731 2.86237705,12.8083442 3.54211213,12.8083442 L16.3421121,12.8083442 C17.0218472,12.8083442 17.5728814,12.25731 17.5728814,11.577575 C17.5728814,10.8978399 17.0218472,10.3468057 16.3421121,10.3468057 L3.54211213,10.3468057 Z M4.03441982,4.42242503 C3.35468474,4.42242503 2.80365059,4.97345919 2.80365059,5.65319426 C2.80365059,6.33292934 3.35468474,6.88396349 4.03441982,6.88396349 L10.4344198,6.88396349 C11.1141549,6.88396349 11.665189,6.33292934 11.665189,5.65319426 C11.665189,4.97345919 11.1141549,4.42242503 10.4344198,4.42242503 L4.03441982,4.42242503 Z" />
      </g>
    </g>
  </svg>
);

PodcastIcon.defaultProps = defaultProps;

export default PodcastIcon;
